<template>
  <a-card :bordered="false">
     <div class="table-page-search-wrapper">
      <a-form layout="inline" @submit="handleSearch" :autoFormCreate="(form)=>{this.searchForm = form}">
        <a-row :gutter="48">
        
         
          <a-col :md="8" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" htmlType='submit'>查询</a-button>
              <a-divider type="vertical" />
               <a-button type="primary" @click="handleAdd" icon="plus">新建</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <s-table
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
    >
      <template slot="image_url" slot-scope="text,record">
        <span><img :src="record.image_url" style="width: 125px; height: 60px;"></span>
      </template>
      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical" />
        <a @click="handleDel(record)">删除</a>
      </span>
    </s-table>
  <!-- 编辑/新建轮播图 -->
    <a-modal
      :title="modal_title"
      :width="1000"
      v-model="visible"
      @ok="handleOk"
    >
      <a-form :autoFormCreate="(form)=>{this.form = form}">
       
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label='排序'
          fieldDecoratorId="weights"
          :fieldDecoratorOptions="{rules: [{ required: false}],
            initialValue: mdl.weights,
          }"
        >
          <a-input-number :min="1" :max="255" placeholder="0-255越大排序越靠前" />
        </a-form-item>
       
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label='轮播图'
          fieldDecoratorId="image_url"
        >
          <a-upload
            name="file"
            listType="picture-card"
            class="avatar-uploader"
            :showUploadList="false"
            action="//upload.qiniup.com"
            :beforeUpload="beforeUpload"
            :data="imgForm"
            @change="handleChange"
          >
            <img v-if="mdl.image_url" :src="mdl.image_url" alt="avatar" width=200 height=128/>
            <div v-else>
              <a-icon :type="loading ? 'loading' : 'plus'" />
              <div class="ant-upload-text">Upload</div>
            </div>
          </a-upload>
        </a-form-item>

      </a-form>
    </a-modal>
  </a-card>
</template>
<script>
import STable from '@/components/table/'
import { getBannerList, updateBanner, deleteBanner } from '@/api/banner'
import { getQiniuToken } from '@/api/qiniu'
import { getBranchList } from '@/api/branch'

export default {
  name: 'Banner',
  components: {
    STable
  },
  data() {
    return {
      visible: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
      },
      form: null,
      modal_title: '添加轮播图',
      mdl: {},
      imgForm: {},
      bucketHost: '',
      loading: false,
      branches:[],
      // 查询参数
      queryParam: {
        sort: {
          field: 'id',
          reverse: true
        }
      },
      // 表头
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
        },
        {
          title: '排序',
          dataIndex: 'weights',
        },
        {
          title: '图片',
          scopedSlots: { customRender: 'image_url' },
        },
        {
          title: '链接',
          dataIndex: 'image_url',
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: params => {
        return getBannerList(Object.assign(params, this.queryParam)).then(res => res)
      },
    }
  },
  created () {
    this.getBranchList()
  },
  methods: {
    handleSearch(e) {
      e.preventDefault()
      //  this.queryParam = { branch_id: this.searchForm.getFieldValue('branch_id')}
      this.$refs.table.refresh()
    },
    initBanner () {
      this.mdl = {
        id: undefined,
        branch_id: 0,
        category: 'none',
        json_data:'',
        position: 0,
        image_url: '',
        weights: 1
      }
    },
    getBranchList: function () {
      getBranchList().then(res => {
        this.branches = res.list
      })
    },
    handleAdd () {
      this.modal_title = '添加轮播图'
      this.initBanner()
      this.visible = true
    },
    handleOk () {
      this.form.validateFields((err, values) => {
        if (!err) {
          const params = {
            id:this.mdl.id,
            image_url:this.mdl.image_url,
            weights:Number(values.weights)||0,
          }
          updateBanner(params).then(res => {
            this.$refs.table.refresh()
            this.$message.success('操作成功')
            this.form.resetFields()
            this.visible = false
          })
      
        }
      })
      
    },
    handleEdit (record) {
      this.modal_title = '修改轮播图'
      this.mdl = Object.assign({}, record)
      console.log(record)
      this.visible = true
    },
    handleDel (row) {
      const _this = this
      this.$confirm({
        title: '警告',
        content: '真的要删除吗?',
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          deleteBanner(row.id).then(res => {
             _this.$refs.table.refresh()
             _this.$message.success('删除成功')
          })
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    },
    save (row) {
      delete row.editable
      this.$refs.table.updateEdit()
    },
    cancel (row) {
      delete row.editable
      this.$refs.table.updateEdit()
    },
    handleChange (info) {
      console.log(info)
      if (info.file.status === 'uploading') {
        this.loading = true
      } else if (info.file.status === 'done') {
        let key = info.file.response.key
        this.mdl.image_url = `${this.bucketHost}${key}`
        this.loading = false
      } else if (info.file.status === 'error') {
        this.loading = false
        this.$message.error('上传图片失败，请重试')
      }
    },
    beforeUpload: function () {
      let _this = this
      return getQiniuToken().then(res => {
        _this.bucketHost = res.bucket_host
        _this.imgForm = {
          // key: res.key,
          token: res.qiniu_token
        }
      })
    }
  }
}
</script>
<style>
  .avatar-uploader > .ant-upload {
    width: 128px;
    height: 128px;
  }
  .ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
  }

  .ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
  }
</style>
